// 导入组件
import Vue from 'vue';
import Router from 'vue-router';
// 登录
// import login from '@/views/login';
// 首页
import projects from '@/home/homeProjects/homeProjects';
import contracts from '@/home/homeContracts/homeContracts';
import workOrders from '@/home/homeWorkOrders/homeWorkOrders';
import products from '@/home/homeProducts/homeProducts';
import productIssueInfo from '@/home/homeProducts/issueinfo';
import parts from '@/home/homeParts/homeParts';
import contract from '@/contract/index';
import projectinfo from '@/projectinfo/projectinfo';
import contractinfo from '@/contractinfo/contractinfo';
import productioninfo from '@/workordersinfo/productioninfo';
import designinfo from '@/workordersinfo/designinfo';
import abnormalinfo from '@/abnormalinfo/abnormalinfo';
import classification from '@/contract/classification/index';
import details from '@/contract/details/index';
import aftersales from '@/aftersales/index';
import productViewer from '@/viewer/homePage.vue';
import productViewer1 from '@/viewer/overallDashboard/overallDashboard.vue';
import productViewer2 from '@/viewer/WaterQualityDashboard/WaterQualityDashboard.vue';
import processDesign from '@/viewer/ProcessDesign.vue'; // 请根据实际文件路径调整
import stationAdmin from '@/viewer/StationAdmin.vue'; // 工位管理
import StationViewGas from '@/viewer/StationViewGas.vue'; // 工位总览（气体）
import StationInfoGas from '@/viewer/StationInfoGas.vue'; // 工位详情看板（气体）
import aftersaleinfo from '@/aftersales/afterSaleProject';
import aftersalecontractinfo from '@/aftersales/afterSaleContract';
import aftersaleprojectinfo from '@/aftersales/afterSaleProject';


import homepage from '@/components/homepage.vue';

import UserSettings from '@/usersetting/UserSettings.vue';

//登录
import login from '@/login/index';


// 启用路由
Vue.use(Router);

// 导出路由 
export default new Router({
  routes: [
    {
        path: '/',
        name: '',
        component: login,
        hidden: true,
        meta: {
            requireAuth: false
        }
    }, 
    {
        path: '/login',
        name: '登录',
        component: login,
        // hidden: true,
        // meta: {
        //     requireAuth: false
        // }
    }, 
    {
        path: '/productViewer',
        name: '驾驶舱',
        component: productViewer,
        meta: {
            requireAuth: true
        },
        
    },

    {
        path: '/productViewer1',
        name: '驾驶舱1',
        component: productViewer1,
        meta: {
            requireAuth: true
        },
        
    },
    {
        path: '/productViewer2',
        name: '驾驶舱1',
        component: productViewer2,
        meta: {
            requireAuth: true
        },
        
    },
    {
        path: '/processDesign', // 访问路径
        name: '工艺流程设计', // 路由名称，用于显示或编程式导航
        component: processDesign, // 指向刚导入的组件
        meta: {
            requireAuth: true // 如果需要登录才能访问，设置为true
        }
    },
    {
        path: '/stationAdmin', // 访问路径
        name: '工位管理', // 路由名称，用于显示或编程式导航
        component: stationAdmin, // 指向刚导入的组件
        meta: {
            requireAuth: true // 如果需要登录才能访问，设置为true
        }
    },
    {
        // 工位总览（气体）—— homepage.vue 下拉「工位总览（气体）」push 的就是这条路径
        path: '/stationViewGas',
        name: '工位总览（气体）',
        component: StationViewGas,
        meta: {
            requireAuth: true
        }
    },
    {
        // 工位详情看板（气体）—— 从工位总览点击相邻两张桌子下钻进来（?pair=N），
        // 页面内的「返回上一级」会 push 回 /stationViewGas
        path: '/stationInfoGas',
        name: '工位详情看板（气体）',
        component: StationInfoGas,
        meta: {
            requireAuth: true
        }
    },

    {
      path: '/user/settings',
      name: 'UserSettings',
      component: UserSettings,
      meta: {
        title: '个人设置',
        requiresAuth: true  // 需要登录
      }
    },

    // {
    //   path: '/homepage/projects',
    //   name: '项目主页',
    //   component: projects,
    //   meta: {
    //     title: '项目主页',
    //     requiresAuth: true  // 需要登录
    //   }
    // },

    {
        path: '/homepage',
        name: '首页',
        component: homepage,
        iconCls: 'el-icon-tickets',
        children: [
        {
            path: '/homepage/contract',
            name: '合同',
            component: contract,
            meta: {
                requireAuth: true
        },
        
        },
        {
            path: '/homepage/projectinfo',
            name: '项目信息123',
            component: projectinfo,
            meta: {
                requireAuth: true
            },

        },
        {
            path: '/homepage/classification',
            name: '分类进度信息',
            component: classification,
            meta: {
                requireAuth: true
            },
            
        },
        {
            path: '/homepage/details',
            name: '设计详细信息',
            component: details,
            meta: {
                requireAuth: true
            },
            
        },
        {
            path: '/homepage/aftersales',
            name: '售后信息',
            component: aftersales,
            meta: {
                requireAuth: true
            },
            
        },
        
        // ===============项目维度====================
        // 项目主页
        {
            path: '/homepage/projects',
            name: '项目主页',
            component: projects,
            meta: {
                keepAlive: true,
                requireAuth: true
            }
        }, 
        // 项目信息
        {
            // 原路由
            // path: 'projectinfo',
            path: '/homepage/project/:projectNo',
            name: '项目信息',
            component: projectinfo,
            props: true // 将路由参数传递给组件
        },

        // 项目信息页面下透售后信息
        {
        path: '/homepage/project/:projectNo/aftersale',
        name: '项目售后信息',
        component: aftersaleprojectinfo,
        props: true // 将路由参数传递给组件
        },
        

        // 项目下透合同信息
        {
        path: '/homepage/project/:projectNo/contract/:contractId',
        name: '合同信息1',
        component: contractinfo,
        props: true // 将路由参数传递给组件
        },

        // 项目下透合同信息页面下透售后信息
        {
        path: '/homepage/project/:projectNo/contract/:contractId/aftersale',
        name: '合同售后信息2',
        component: aftersalecontractinfo,
        props: true // 将路由参数传递给组件
        },

        // 项目下透合同下透任务生产信息
        {
        path: '/homepage/project/:projectNo/contract/:contractId/production/:workOrderId',
        name: '任务生产信息2',
        component: productioninfo,
        props: true // 将路由参数传递给组件
        },

        // ✅ 项目维度的任务设计信息（URL 只含 projectNo 和 parentModel，contractId 存 sessionStorage）
        {
            path: '/homepage/project/:projectNo/design/:parentModel',
            name: '任务设计信息2',  // ✅ 项目维度
            component: designinfo,
            props: true
        },

        // ===============合同维度====================
        //合同主页        
        {
            path: '/homepage/contracts',
            name: '合同主页',
            component: contracts,
            meta: {
                keepAlive: true,
                requireAuth: true
            }
        }, 

        // // 合同主页直接下透售后信息
        // {
        // path: '/homepage/contracts/aftersale/:contractNo',
        // name: '合同售后信息',
        // component: aftersalecontractinfo,
        // props: true // 将路由参数传递给组件
        // },


        // 合同信息
        {
        path: '/homepage/contract/:contractId',
        name: '合同信息',
        component: contractinfo,
        props: true // 将路由参数传递给组件
        },

        // 合同信息页面下透售后信息
        {
        path: '/homepage/contract/:contractId/aftersale',
        name: '合同售后信息1',
        component: aftersalecontractinfo,
        props: true // 将路由参数传递给组件
        },
        

        // 合同下透任务生产信息
        {
        path: '/homepage/contract/:contractId/production/:workOrderId',
        name: '任务生产信息1',
        component: productioninfo,
        props: true // 将路由参数传递给组件
        },

// ✅ 合同维度的任务设计信息（URL 只含 parentModel，contractId 存 sessionStorage）
{
    path: '/homepage/contract/design/:parentModel',
    name: '任务设计信息1',  // ✅ 合同维度
    component: designinfo,
    props: true
},        


         // ===============任务单维度====================
        //任务主页        
        {
            path: '/homepage/workOrders',
            name: '任务单主页',
            component: workOrders,
            meta: {
                keepAlive: true,
                requireAuth: true
            }
        }, 

        // 任务生产信息
        {
        path: '/homepage/workOrder/production/:workOrderId',
        name: '任务生产信息',
        component: productioninfo,
        props: true // 将路由参数传递给组件
        },

        // 任务设计信息
        {
        path: '/homepage/workOrder/design/:parentModel',
        name: '任务设计信息',
        component: designinfo,
        props: true // 将路由参数传递给组件
        },

         // ===============产品维度====================
        //产品主页        
        {
            path: '/homepage/products',
            name: '产品主页',
            component: products,
            meta: {
                keepAlive: true,
                requireAuth: true
            }
        }, 
        //产品问题信息（产品主页「问题列表」入口）
        {
            path: '/homepage/products/issueinfo',
            name: '产品问题信息',
            component: productIssueInfo,
            meta: {
                requireAuth: true
            }
        }, 
        //部件主页        
        {
            path: '/homepage/parts',
            name: '部件主页',
            component: parts,
            meta: {
                keepAlive: true,
                requireAuth: true
            }
        }, 



        // ===============总维度====================
        //异常主页        
        {
            path: '/homepage/abnormalinfo',
            name: '异常信息',
            component: abnormalinfo,
            meta: {
                requireAuth: true
            }
        }, 
        //售后主页        
        {
            path: '/homepage/aftersaleinfo',
            name: '售后信息',
            component: aftersaleinfo,
            meta: {
                requireAuth: true
            }
        }, 

      ]
    },

  ]
})